import React from 'react';
import './CarouselCreditCardOffer.scss';

const RegularAPR = ({aprDetails}) => {
    return (
      <div className="regularAPRBlock">
        <div className="regularAPRTitle" data-testid="regularAPRLabel">
          Regular APR
        </div>
        <div className="regularAPR">
          <div
            data-testid="regularAPR"
            className="regularAPRText"
            dangerouslySetInnerHTML={{
              __html: aprDetails,
            }}
          />
        </div>
      </div>
    );
  };

  export default RegularAPR;